import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M0 11.04C0 18.335 2.744 22 8.197 22c3.078 0 5.287-1.167 6.458-3.243 1.204-2.075 1.673-4.475 1.673-7.718 0-3.242-.469-5.707-1.673-7.782C13.484 1.18 11.275.014 8.197.014 2.744.014 0 3.678 0 11.039m4.684 0q0-6.615 3.513-6.616c2.309 0 3.447 2.205 3.447 6.615 0 4.378-1.138 6.55-3.447 6.55-2.342 0-3.513-2.172-3.513-6.55m22.2 1.428c3.28-.097 3.045 2.4 2.978 2.821-.134 1.168-1.539 2.368-3.145 2.27-.636-.032-1.271-.227-1.907-.648s-1.104-.908-1.338-1.395l-4.116 1.979c1.205 2.464 3.948 4.28 6.993 4.442 2.175.162 4.115-.357 5.822-1.524 1.706-1.2 2.643-2.692 2.81-4.507.1-1.168-.2-2.303-.903-3.438s-1.673-1.913-2.844-2.335c1.706-.908 2.81-2.464 2.81-4.15.034-1.524-.568-2.886-1.806-4.054C31 .727 29.428.111 27.553.014c-2.91-.162-5.487 1.102-6.825 3.145l3.78 2.238q.754-1.167 2.31-1.167c1.471 0 2.208 1.167 2.208 2.043 0 1.524-.703 2.302-2.142 2.302h-2.308v3.891z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }